export default "__VITE_ASSET__CNdKC_QB__"